define([
  "underscore",
  "jquery"
], function(
    _,
    $
  ) {
    var MODAL_ID = "mindbreeze-alert-modal";
    var MODAL_BODY_ID = "mindbreeze-alert-modal-body";

    var ErrorModalHandler = function(modalTitle) {
      if (!modalTitle) {
        modalTitle = 'Error';
      }

      function getHTML(okLabel, cancelLabel) {
        let ok = 'OK', cancel = 'Cancel';
        if (okLabel) ok = okLabel;
        if (cancelLabel) cancel = cancelLabel;
        var modalHTML = '<div class="modal-dialog" role="document">' +
        ' <div class="modal-content">' +
        '  <div class="modal-header mb-dont-serialize mb-computing" aria-busy="true">' +
        '     <button class="close" data-dismiss="modal" tabindex="-1">✕</button>' +
        '      <h2 class="modal-title"><i class="icon-cog"></i>' + modalTitle +'</h2>' +
        '  </div>' +
        '  <div class="modal-body" id="' + MODAL_BODY_ID + '">' +
        '  </div>' +
        '  <div class="modal-footer">' +
           ' <button type="button" class="btn btn-mb-default btn-confirm">'+ ok +'</button>' +
           ' <button type="button" class="btn btn-mb-default" data-dismiss="modal">'+ cancel +'</button>' +
         '</div> ' +
        '</div>' +
      '</div>';

      return modalHTML;
      }

      function addError(content, id, okLabel, cancelLabel) {
        if (!modalExistsInDOM()) {
          addModalToDOM(okLabel, cancelLabel);
        }

        addAlert(content, id);
        showModal();
      }

      function confirm(content, okLabel, cancelLabel, onConfirm, onCancel) {
        if (!modalExistsInDOM()) {
          addModalToDOM(okLabel, cancelLabel);
        } else {
          removeModalFromDOM()
        }

        addConfirm(content);
        showModal();

        $('.modal#' + MODAL_ID + " .btn-confirm").on("click", function() {
          onConfirm();
          $('#' + MODAL_ID).modal( 'hide' );
          removeModalFromDOM();
        });
      }

      function modalExistsInDOM() {
        return !!document.getElementById(MODAL_ID);
      }

      function addModalToDOM(okLabel, cancelLabel) {
        var modal = document.createElement('div');
        modal.className = 'modal ' + MODAL_ID;
        modal.id = MODAL_ID;
        modal.innerHTML = getHTML(okLabel, cancelLabel);

        document.body.appendChild(modal);

        $(modal).on("hidden", function () {
          removeModalFromDOM();
        });
      }

      function removeModalFromDOM() {
        $('#' + MODAL_ID).remove();
      }

      function showModal() {
        var modal = document.getElementById(MODAL_ID);

        if (!modal) {
          console.error('Error modal does not exist in DOM');
          return;
        }

        $(modal).modal();
      }

      function addAlert(content, alertID) {
        // Dashify
        alertID = !alertID ? generateRandomID() : alertID.replace(/[:\/\.]/g, '-');

        var alertHTML = '<div class="alert alert-danger modal-alert-' + alertID + '" role="alert">' + content + '</div>';

        if(alertExists(alertID)) {
          return;
        }

        $('#' + MODAL_BODY_ID).append(alertHTML);
      }

      function addConfirm(content, alertID) {
        // Dashify
        alertID = !alertID ? generateRandomID() : alertID.replace(/[:\/\.]/g, '-');

        var alertHTML = '<div role="alert">' + content + '</div>';

        if(alertExists(alertID)) {
          return;
        }

        $('#' + MODAL_BODY_ID).append(alertHTML);
      }

      function generateRandomID() {
        return _.uniqueId();
      }

      function alertExists(alertID) {
        return $('#' + MODAL_BODY_ID + ' > .modal-alert-' + alertID).length > 0;
      }

      return {
        addError: addError,
        confirm: confirm
      }
    };

    return ErrorModalHandler;
  });
